<template>
  <f-form
    store="@admin/roles"
    :id="roleId"
  >
    <template #default="{ item }">
      <div class="is-grid">
        <f-field 
          class="is-col-6"
          label="Intitulé"
        >
          <f-input 
            v-model="item.name"
            suffix-icon="user"
            :readonly="!canEdit"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-6"
          label="Slug"
        >
          <f-input 
            v-model="item.slug"
            suffix-icon="cog"
            :readonly="!canEdit"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-6"
          label="Services"
        >
          <f-select
            v-model="chosenServices"
            :options="servicesOptions"
            :readonly="!canEdit"
            label="name"
            value="slug"
            multiple
            long
          >
          </f-select>
        </f-field>

        <f-field 
          class="is-col-6"
          label="Permissions"
        >
          <f-select
            v-model="item.permissions"
            :options="permissionsChoices"
            :readonly="!canEdit"
            multiple
            long
          >
          </f-select>
        </f-field>
      </div>
    </template>
  </f-form>
</template>

<script>
  import { computed, reactive, toRefs } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'
  import useRoles from '@composables/use-roles'

  export default {
    setup () {
      const { checkPermissions } = useRoles()
      
      const canEdit = computed(() => 
        checkPermissions('roles:patch')
      )

      const roleId = computed(() => router.currentRoute.value.params.role_id)

      const services = [{
        name: 'Tout',
        slug: '*',
      }, {
        name: 'Rôles',
        slug: 'roles',
      }, {
        name: 'Admins',
        slug: 'users',
      }, {
        name: 'Users',
        slug: 'freebe/users',
      }, {
        name: 'Entrepreneurs',
        slug: 'freebe/entrepreneurs',
      }, {
        name: 'Mandats',
        slug: 'freebe/gocardless/mandates',
      }, {
        name: 'Souscriptions',
        slug: 'freebe/pricing/subscriptions',
      }, {
        name: 'Partenaires',
        slug: 'partners',
      }, {
        name: 'Partenaires - stats',
        slug: 'partners/stats',
      }, {
        name: 'Cashbacks',
        slug: 'partners/cashbacks',
      }, {
        name: 'Codes',
        slug: 'freebe/pricing/codes',
      }, {
        name: 'Statistiques - État',
        slug: 'statistics/state',
      }, {
        name: 'Statistiques - Périodique',
        slug: 'statistics/periodic',
      }, {
        name: 'Factures & devis',
        slug: 'freebe/documents',
      }]

      const state = reactive({
        chosenServices: services.map(service => service.slug),
        servicesOptions: [...services],
        permissionsChoices: computed(() => {
          let permissionsChoices = []

          if (state.chosenServices.length > 0) {
            for (var i = 0; i < state.chosenServices.length; i++) {
            permissionsChoices.push(
              state.chosenServices[i] + ':*',
              state.chosenServices[i] + ':get',
              state.chosenServices[i] + ':find',
              state.chosenServices[i] + ':patch',
              state.chosenServices[i] + ':create',
              state.chosenServices[i] + ':remove',
            )
          } 

          return permissionsChoices
          } else {
            return []
          }
        })
      })
      
      return {
        roleId,
        ...toRefs(state),
        canEdit,
      }
    } 
  }
</script>